import { Directive, Input, ViewContainerRef, ElementRef, Pipe, PipeTransform, OnInit, Renderer2 } from '@angular/core';
import { L10nTranslationService } from '@snack-dev/angular-l10n';
import { LocaleService } from '../services/locale.service';

@Directive({
  selector: '[hsLang]'
})
export class HsLangDirective {

  @Input() set hsLang(langKey: string) {
    const text = this.translation.translate(langKey);
    this.element.innerHTML = '<p>' + text + '</p>';
    this.element.setAttribute('data-editable', 'true');
    this.element.setAttribute('data-name', langKey);
  }

  private element: HTMLElement;

  constructor(
    private viewContainer: ViewContainerRef,
    private translation: L10nTranslationService,
    private host: ElementRef<HTMLElement>
  ) {
    this.element = host.nativeElement;
  }

}


@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[lang]'
})
export class LangDirective implements OnInit {

  @Input() lang: string;
  @Input() params: any;
  @Input() html = false;

  constructor(
    private translation: L10nTranslationService,
    private locale: LocaleService,
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (!this.lang) {
      this.lang = this.host.nativeElement.textContent?.trim() || (this.host.nativeElement as any).data?.trim();
    }
    if (this.lang) {
      if (this.html) {
        this.renderer.setProperty(this.host.nativeElement, 'innerHTML', this.translation.translate(this.lang, this.params, this.locale.lang));
      } else {
        this.renderer.setProperty(this.host.nativeElement, 'innerText', this.translation.translate(this.lang, this.params, this.locale.lang));
      }
    }
  }

}

@Pipe({
  name: 'lang',
  pure: true
})
export class LangPipe implements PipeTransform {

  constructor(private locale: LocaleService, private translation: L10nTranslationService){}

  transform(key: string, params?: any): string | null {
    return this.translation.translate(key, params, this.locale.lang);
  }
}
